import { useState, useEffect } from 'react';
import { debounce } from 'src/utils/debounce';
import { getDeviceFlags, deviceContext } from './index';

export const DeviceProvider = ({ children }: { children: React.ReactNode }) => {
  const [device, setDevice] = useState(() => getDeviceFlags(window));

  useEffect(() => {
    const handleResize = debounce(() => {
      setDevice(getDeviceFlags(window));
    }, 0);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <deviceContext.Provider value={device}>{children}</deviceContext.Provider>
  );
};
